<template>
  <div>Hello from Ranking</div>
</template>

<script>
export default {
  name: "Ranking"
};
</script>